// removed by extract-text-webpack-plugin
module.exports = {"ObservationButton":"ObservationButton","observationButton":"ObservationButton","c-button--active":"c-button--active","cButtonActive":"c-button--active","ObservationButton--active":"ObservationButton--active","observationButtonActive":"ObservationButton--active","ObservationButton--inactive":"ObservationButton--inactive","observationButtonInactive":"ObservationButton--inactive"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/ObservationButton.scss
// module id = 422
// module chunks = 0